<div class="RegContainer mt-2">
    <h1>Регистрация РацОрга</h1>
    <form [formGroup]="ratsorgForm">
        <label>Ваши ФИО</label>
        <span *ngIf="
         ratsorgForm.get('firstName').errors &&
         ratsorgForm.get('firstName').hasError('required') ||
         ratsorgForm.get('lastName').errors &&
         ratsorgForm.get('lastName').hasError('required') ||
         ratsorgForm.get('middleName').errors &&
         ratsorgForm.get('middleName').hasError('required')
            " style="color: red">*</span>
        <div class="row justify-content-center">
            <input formControlName="lastName" style="max-width: 235px" class="form-control mr-2" placeholder="Укажите фамилию" />
            <input formControlName="firstName" style="max-width: 200px" class="form-control mr-2" placeholder="Укажите имя" />
            <input formControlName="middleName" style="max-width: 230px" class="form-control" placeholder="Укажите отчество" />
        </div>
        <span style="color: red" *ngIf="validFIO">Обязательные поля</span><br *ngIf="validFIO">
        <br>
        <label>Место работы (предприятие)</label>
        <br>
        <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Укажите название организации</mat-label>
            <input type="text"
                   placeholder="Укажите название организации"
                   aria-label="Укажите название организации"
                   matInput
                   formControlName="userblockInput"
                   [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBlockName" (optionSelected)="onBlockSelected($event.option)">
                <mat-option *ngFor="let block of blocks | async" [value]="block">{{block.name}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <span style="color: red" *ngIf="validBlock">Обязательное поле</span><br *ngIf="validBlock">
        <label style="font-style: italic">В списке представлены только предприятия - участники конкурса. Если Вашего предприятия нет в списке, его необходимо зарегистрировать со стороны Куратора</label>
        <br>

        <label>ИНН Организации</label>
        <span *ngIf="ratsorgForm.get('Inn').errors && ratsorgForm.get('Inn').hasError('required')" style="color: red">*</span>
        <input class="form-control" formControlName="Inn" type="text" placeholder="ИНН Организации" disabled />
        <span style="color: red" *ngIf="validInn">Обязательное поле</span><br *ngIf="validInn">
        <br>

        <label>Ваш телефон</label>
        <span style="color: red" *ngIf="!(phoneInputComponent.phoneValueWithRegion.length > 10)">*</span>
        <app-phone-input>
        </app-phone-input>
        <span style="color: red" *ngIf="validPhone">Обязательное поле</span><br *ngIf="validPhone">

        <br>
        <label>Ваша электронная почта</label>
        <span *ngIf="
         ratsorgForm.get('email').errors &&
         ratsorgForm.get('email').hasError('required') ||
         ratsorgForm.get('email').hasError('email')" style="color: red">*</span>
        <br>
        <label class="mt-0">Пароль для входа в систему будет отправлен на указанный email</label>
        <input class="form-control" formControlName="email" type="text" placeholder="example@org.ru" />
        <span style="color: red" *ngIf="validEmail">Обязательное поле</span><br *ngIf="validEmail">

        <label>Дата рождения</label>
        <span *ngIf="ratsorgForm.get('birthDate').errors && ratsorgForm.get('birthDate').hasError('required')" style="color: red">*</span>
        <input type="date" max="{{dateNow | date: 'yyyy-MM-dd'}}" formControlName="birthDate" class="form-control" required />
        <span style="color: red" *ngIf="validbirthdate">Обязательное поле</span><br *ngIf="validbirthdate">
        <br>

        <label>Приложите описание Ваших успешных практик организации рационализаторской деятельности</label>
        <input type="file" accept="application/pdf, .doc, .docx" multiple class="form-control" (change)="loadFiles($event)" />
        <label>Максимальный размер файла: 100 Мб</label><br>
        <label>Допустимые форматы: .doc, .docx, pdf</label>
        <br>
        <input type="checkbox" formControlName="userAgreement" style="width: 15px; height: 15px" class="mr-2" id="userAgreement"/><label for="userAgreement">Я принимаю <a href="themes/default/assets/documents/Пользовательское_соглашение_Конкурс_last.pdf" target="_blank">Пользовательское соглашение</a></label>
        <span *ngIf="ratsorgForm.get('userAgreement').errors || ratsorgForm.get('userAgreement').hasError('requiredTrue')" style="color: red">*</span>
        <br *ngIf="validUserAgreement"><span style="color: red" *ngIf="validUserAgreement">Обязательное поле</span>
        <br>

        <input type="checkbox" formControlName="personalData" style="width: 15px; height: 15px" class="mr-2" id="personalData"/><label for="personalData">Я соглашаюсь с <a href="themes/default/assets/documents/Согласие%20ПнД.pdf" target="_blank">Политикой обработки персональных данных</a></label>
        <span *ngIf="ratsorgForm.get('personalData').errors || ratsorgForm.get('personalData').hasError('requiredTrue')" style="color: red">*</span>
        <br *ngIf="validPersonalData"><span style="color: red" *ngIf="validPersonalData">Обязательное поле</span>
        <br>
        <app-captcha #captchaComponent></app-captcha>
        <input id="captchaCode"
               name="captchaCode"
               [(ngModel)]="captchaCode"
               class="form-control"
               autocomplete="off"
               placeholder="{{ 'Common.CaptchaText' | translate }}"
               type="text"/>
        <br>
        <br *ngIf="invalidCaptcha"><span style="color: red" *ngIf="invalidCaptcha">Неверно. Попробуйте еще раз!</span>
        <div class="col text-center">
            <button [disabled]="lockSubmitButton" type="button" class="btn btn-primary" (click)="submitRegistration()">Зарегистрироваться</button>
        </div>
    </form>

</div>
